/** jQuery JavaScript for allinone functionality **/
(function (allinone, $) {

    /**
     * Initializes the pie chart
     */
    allinone.initPieChart = function (chartData) {
        var json = JSON.parse(chartData);
        new Chart($("#BalanceChart"), {
            type: "pie",
            data: {
                labels: json.Labels,
                datasets: [
                    {
                        data: json.Data,
                        backgroundColor: ["#073F21", "#1F284E", "#7A8E8D"]
                    }
                ]
            },
            options: {
                title: {
                    display: true,
                    text: "Uren geldig t/m",
                    align: "center"

                },
                tooltips: {
                    enabled: false
                },
                plugins: {
                    datalabels: {
                        color: "white",
                        anchor: "end",
                        align: "start",
                        font: {
                            weight: "bold"
                        },
                        formatter: function (value, context) {
                            return value !== 0 ? value + " uur" : ""
                        }
                    }
                }
            }
        });
    }

    /**
     * Initializes the bar chart
     */
    allinone.initBarChart = function (chartData) {
        var json = JSON.parse(chartData);
        new Chart($("#PastMonthsChart"), {
            type: "bar",
            data: {
                datasets: [
                    {
                        label: "Aantal uur abonnement",
                        data: json.LineData,
                        borderColor: "#4A4A4A",
                        backgroundColor: "#4A4A4A",
                        fill: false,
                        type: "line",
                        lineTension: 0
                    },
                    {
                        label: "Aantal uur verbruikt",
                        data: json.BarData,
                        backgroundColor: "#50A182"
                    },
                    {
                        label: "Buiten abonnement verbruikt",
                        data: json.BarOutsideSubscriptionData,
                        backgroundColor: "#E4E8E8"
                    }
                ],
                labels: json.Labels

            },
            options: {
                layout: {
                    padding: {
                        left: 10,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                scales: {
                    yAxes: [
                        {
                            stacked: true,
                            ticks: {
                                beginAtZero: true,
                                suggestedMax: Math.ceil(Math.max.apply(null, json.LineData.concat(json.BarData)) * 1.1)
                            }
                        }
                    ],
                    xAxes: [
                        {
                            stacked: true
                        }
                    ]
                },
                tooltips: {
                    mode: "index"
                },
                plugins: {
                    datalabels: { display: false }
                }
            }
        });
    }

    /**
    * Initializes the slider
    */
    allinone.initSlider = function (hasPaidSubscription) {
        let slider = $(".slider-aio > #subscription-amount-slider");

        let freeBalance = parseFloat(slider.attr("data-slider-aiofree"));
        let maximumBalance = parseFloat(slider.attr("data-slider-aiomax"));

        slider.slider({
            tooltip: 'always',
            step: 0.25,
            precision: 2,
            min: 0,
            max: maximumBalance,
            ticks: GetTicks(freeBalance, maximumBalance),
            lock_to_ticks: true
        }).on("change", (event) => { validateValue(event); updateToolTip(event); })
            .data("slider");

        $('[data-toggle="tooltip"]').tooltip({ animation: true, html: true, title: getToolTip(), customClass: "all-in-one-tooltip" });

        // Gets the valid values for the slider
        function GetTicks(free, max) {
            let ticks = [0, max];
            for (let i = 0; i < max; i++) {
                ticks.push(i + free);
            }
            return Array.from(new Set(ticks.sort()));
        }

        function updateToolTip(event) {
            $('[data-toggle="tooltip"]').tooltip('dispose').tooltip({ animation: true, html: true, title: getToolTip(), customClass: "all-in-one-tooltip" });
        }

        function getToolTip() {
            let slider = $(".slider-aio > #subscription-amount-slider");

            let nearestQuarter = $('#nearestQuarter').val();
            let freeBalance = parseFloat(slider.attr("data-slider-aiofree"));
            let totalBalance = parseFloat(slider.attr("data-value"));
            let paidBalance = totalBalance - freeBalance;

            // parse the floats to an int so we don't have to mind any precision
            let freeBalanceText = parseInt(freeBalance) === 1.0 ? `<b>${freeBalance}</b> gratis uur` : `<b>${freeBalance}</b> gratis uren`
            let paidBalanceText = parseInt(paidBalance) === 1.0 ? `<b>${paidBalance}</b> betaalde uur` : `<b>${paidBalance}</b> betaalde uren`

            return `Per <b>${nearestQuarter}</b> bundel aanpassen naar: <ul><li>${freeBalanceText}</li><li>${paidBalanceText}</li></ul>`;
        }

        // Validates if the value is within the allowed range
        function validateValue(event) {
            let alertMessage = $(".slider-aio > .alert.alert-aio");
            let freeBalance = parseFloat(slider.attr("data-slider-aiofree"));

            if (hasPaidSubscription === "False") {
                SetInfoMessage("Er is geen betaald abonnement aanwezig. Neem contact op met jouw contactpersoon.", freeBalance);
                return;
            }

            let newValue = event.value.newValue;
            let minimumBalance = parseFloat(slider.attr("data-slider-aiomin"));
            let maximumBalance = parseFloat(slider.attr("data-slider-aiomax"));

            if (newValue < minimumBalance) {
                if (!(freeBalance < minimumBalance) && newValue < minimumBalance) {
                    SetInfoMessage("Je kunt niet minder uren afnemen dan het aantal gratis uren.", freeBalance);
                }
                else if (newValue < minimumBalance) {
                    SetInfoMessage("Wil je lager dan het minimum neem dan contact op met jouw contactpersoon.", minimumBalance);
                }
            }
            else if (newValue >= (maximumBalance + freeBalance)) {
                SetInfoMessage("Wil je hoger dan het maximum neem dan contact op met jouw contactpersoon.", maximumBalance + freeBalance);
            }
            else {
                alertMessage.hide("fast");
                SetSlider(newValue);
            }

            function SetInfoMessage(text, value) {
                alertMessage.text(text);
                alertMessage.show("fast");
                SetSlider(value);
            }

            function SetSlider(value) {
                slider.slider('setValue', value);
                $("#modalNewHours").text(value);
            }
        }
    }

    /**
    * Init the datatables
    */
    allinone.initBundleTable = function (calculationLines) {
        $.fn.dataTable.moment('DD-MM-YYYY HH:mm');
        let tableDom = "<'row buttons-row' B><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-6 d-flex'l<'px-2'i>><'col-sm-12 col-md-6 dataTables_pager'p>>";
        let defaultOptions = datatable.defaultDatatableOptions();
        $('#allInOneBundleTable').DataTable({
            dom: tableDom,
            data: calculationLines,
            buttons: [
                {
                    extend: 'excel',
                    text: 'Exporteren',
                    className: 'btn btn-primary',
                    exportOptions: {
                        modifier: {
                            page: 'current'
                        }
                    }
                }
            ],
            pageLength: defaultOptions.pageLength,
            lengthMenu: defaultOptions.lengthMenu,
            language: defaultOptions.language,
            columns: [
                {
                    title: 'Datum',
                    data: 'date'
                },
                {
                    title: 'Medewerker',
                    data: 'employeeName'
                },
                {
                    title: 'Aantal',
                    data: 'amount'
                },
                {
                    title: 'Omschrijving',
                    data: 'calculationDescription'
                }
            ],
            columnDefs: [
                {
                    targets: 0,
                    render: function (data, type, full, meta) {
                        return datatable.dutchDateFormat(data, "DD-MM-YYYY HH:mm")
                    }
                }
            ],
            order: [[0, 'desc']]
        });

        // Remove dt-button class from the buttons
        $('.dt-button').removeClass('dt-button');
    }

    allinone.initSubscriptionTable = function (subscriptionLines) {
        $.fn.dataTable.moment('DD-MM-YYYY HH:mm');
        let tableDom = "<'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-6 d-flex'l<'px-2'i>><'col-sm-12 col-md-6 dataTables_pager'p>>";
        let defaultOptions = datatable.defaultDatatableOptions();
        $('#allInOneSubscriptionTable').DataTable({
            dom: tableDom,
            data: subscriptionLines,
            pageLength: defaultOptions.pageLength,
            lengthMenu: defaultOptions.lengthMenu,
            language: defaultOptions.language,
            columns: [
                {
                    title: 'Omschrijving',
                    data: 'description'
                },
                {
                    title: 'Aantal',
                    data: 'amount'
                },
                {
                    title: 'Begindatum',
                    data: 'startDate'
                },
                {
                    title: 'Einddatum',
                    data: 'endDate'
                }
            ],
            columnDefs: [
                {
                    targets: [2, 3],
                    render: function (data, type, full, meta) {
                        if(data == null) {
                            return '';
                        }

                        return datatable.dutchDateFormat(data, "DD-MM-YYYY")
                    }
                }
            ],
            order: [[3, 'desc']]
        });
    }

    /**
    * Bind edit subscription event
    */
    allinone.bindEditSubscriptionEvent = function () {
        $("#editSubscription").click(function () {
            $('.nav-tabs a[href="#subscription"]').tab('show');
        });
    }

    allinone.onSubmit = function (button) {
        global.DisableButton(button);
        global.ShowButtonSpinner(button);
    }

}(window.allinone = window.allinone || {}, jQuery));
